import { GETALLCUSTOMERLIST_SUCCESS, GETALLCUSTOMERLIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getAllCustomerlistReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETALLCUSTOMERLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETALLCUSTOMERLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getAllCustomerlistReducer;



